
/*
 * Data provider Ids
 */

export const navigationDataProviderId = "ms.vss-code-web.navigation-data-provider";
export const versionControlDataProviderId = "ms.vss-code-web.versioncontrol-viewmodel-data-provider";
export const CommitDetailsDataProviderId = "ms.vss-code-web.commit-details-view-data-provider";
export const TfvcDetailsDataProviderId = "ms.vss-code-web.tfvc-details-view-data-provider";

/*
 * Context menu icon bowtie classes
 */

export const bowtieIcon = "bowtie-icon";
export const bowtieMathPlusLight = "bowtie-math-plus-light";
export const bowtieTfvcPullRequest = "bowtie-tfvc-pull-request";
export const bowtieFavoriteOutline = "bowtie-favorite-outline";
export const bowtieFavorite = "bowtie-favorite";
export const bowtieTrash = "bowtie-trash";
export const bowtieFile = "bowtie-file";
export const bowtieNavigateHistory = "bowtie-navigate-history";
export const bowtieDiffSideBySide = "bowtie-diff-side-by-side";
export const bowtieTfvcCompare = "bowtie-tfvc-compare";
export const bowtieSecurityLock = "bowtie-security-lock";
export const bowtieSecurityUnlock = "bowtie-security-unlock";
export const bowtiePolicy = "bowtie-policy";
export const bowtieSecurity = "bowtie-security";
export const bowtieTransferDownload = "bowtie-transfer-download";
export const bowtieRestore = "bowtie-recycle-bin-restore";

/*
* Scopes for querying source.
*/

export const project = "project";